/** 创伤医学 */

/** 对应的标题 */
const categoryMap = {
  AVPU: 'AVPU 分级',
  ISS: '创伤程度评分',
  FOUR: 'FOUR 昏迷评分',
  NACA: 'NACA 分级',
  CanadianCSpine: '加拿大颈椎规则',
  CanadianCTHeadRule: '加拿大头颅 CT 规则',
  NewOrleans: 'New Orleans 标准',
  NexusIIHeadCT: 'Nexus II 头颅 CT 规则',
  NexusCSpine: 'Nexus 颈椎摄片规则',
  OttawaAnkleRule: 'Ottawa 踝关节骨折诊断规则',
  OttawaKneeRule: 'Ottawa 膝关节骨折诊断规则',
  ASIA: 'ASIA 损伤分级',
  Teeth: '牙齿编号',
  Fisher: 'FISHER 分级',
  BurnTBSA: '烧伤面积（新九分法）',
  CPOT: 'CPOT',
  ABSI: '简易烧伤程度指数',
  RevisedTraumaScore: '创伤评分（修订版）',
  TASH: 'TASH',
  WFNS: 'WFNS SAH 分级',
  OxygenTankRemainingTime: '氧气瓶剩余时间',
  BurnFluidReplacement: '烧伤补液公式',
  Burn: '烧伤补液（延迟入院）',
  EvansBrooke: 'Evans和Brooke公式',
  Weir: '间接测热法（Weir）',
  BurnDeep: '烧伤深度分级',
  BurnNutrition: '烧伤营养公式',
}
/** 对应的描述 */
const categoryDescMap = {
  AVPU: '意识状态评估',
  ISS: '重大创伤评分',
  FOUR: '昏迷状态详细评估',
  NACA: '患者转移分级',
  CanadianCSpine: '颈椎差创伤后是否需要行 CT 检查',
  CanadianCTHeadRule: '头部创伤是否需要要行 CT 检查',
  NewOrleans: '头部外伤后是否需要 CT 检查',
  NexusIIHeadCT: '头部外伤后是否需要 CT 扫描',
  NexusCSpine: '颈椎损伤后是否需要摄片',
  OttawaAnkleRule: '踝/足外伤后是否需要摄片',
  OttawaKneeRule: '膝关节外伤后是否需要摄片',
  Teeth: '通用编号系统',
  BurnTBSA: '快速估计烧伤面积',
  Fisher: '蛛网膜下腔出血分级系统',
  ASIA: '美国脊髓损伤协会',
  ABSI: '烧伤预后',
  RevisedTraumaScore: '判断是否收治创伤中心',
  TASH: '创伤患者大量输血概率',
  WFNS: '蛛网膜下腔出血分级系统',
  OxygenTankRemainingTime: '氧气瓶还能用多久？',
  BurnFluidReplacement: '全国烧伤会议推荐公式',
  Burn: '适用于烧伤后约6h入院患者的补液量计算',
  EvansBrooke: '用于特大面积烧伤的补液量计算',
  Weir: '计算机体24h静息耗能',
  BurnDeep: '三度四分法',
  BurnNutrition: '估算烧伤病人热能需要量',
}
export default {
  categoryMap,
  categoryDescMap
}



// WEBPACK FOOTER //
// ./src/utils/category/Trauma.js